import {
  dbReducerNorm,
  ReduxFindByIdNorm,
  ReduxInsert,
  ReduxRemove,
} from '@weblite/persist'
import { StatusType } from '@weblite/ts-action/user'

const COLLECTION = 'usersStatus'

// TODO impl custom redux-only keyval storage
export const usersStatusStorage = {
  del(userId: string) {
    ReduxRemove(COLLECTION, { id: userId })
  },

  get(userId: string): StatusType {
    return ReduxFindByIdNorm(COLLECTION, userId)?.status
  },

  set(userId: string, status: StatusType) {
    ReduxInsert(COLLECTION, { id: userId, status })
  },

  add(stats: { id: string; status: StatusType }[]) {
    ReduxInsert(COLLECTION, stats)
  },
}

export const usersStatusReducer = dbReducerNorm(['main', COLLECTION])

export const invalidatedUserStatus = new Set<string>()
